import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { Relocation } from '../types';
import { TableHeader } from './TableHeader';

interface PropTypes {
  relocations: Relocation[];
}

const TableRow = ({ relocation }: { relocation: Relocation }) => (
  <Table.Row>
    <Table.Cell collapsing>{relocation.vacateNumber}</Table.Cell>
    <Table.Cell collapsing>{relocation.vacateCode}</Table.Cell>
    <Table.Cell collapsing>{relocation.phn}</Table.Cell>
    <Table.Cell collapsing>{relocation.streetAddress}</Table.Cell>
    <Table.Cell collapsing>{relocation.borough}</Table.Cell>
  </Table.Row>
);

const RelocationTab = (props: PropTypes) => {
  const [sortedRelocations, setSortedRelocations] = useState<Relocation[]>([]);

  useEffect(() => {
    if (props.relocations) {
      setSortedRelocations(props.relocations);
    }
  }, [props.relocations]);
  return (
    <React.Fragment>
      {sortedRelocations.length === 0 ? (
        <div>No Records Available</div>
      ) : (
        <Table striped columns={5} sortable>
          <TableHeader
            columnNames={[
              'Vacate Number',
              'Vacate Code',
              'Primary House Number',
              'Street Address',
              'Borough',
            ]}
            sortedData={sortedRelocations}
            setSortedData={setSortedRelocations}
          />
          <Table.Body>
            {sortedRelocations.map(hf => (
              <TableRow relocation={hf} />
            ))}
          </Table.Body>
        </Table>
      )}
    </React.Fragment>
  );
};

export default RelocationTab;
